/** Money in the order's own currency, with cents (PO totals are exact; the KPI helper rounds to 0 dp). */
export const formatOrderTotal = (amount: number, currency: string): string => {
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency,
      currencyDisplay: "code",
    }).format(amount);
  } catch {
    return `${currency} ${amount}`;
  }
};
